import { createSlice } from '@reduxjs/toolkit'

export interface INakbState {}

const initialState: INakbState = {}

const ariaSlice = createSlice({
  name: '@aria',
  initialState: initialState,
  reducers: {},
})

export const {} = ariaSlice.actions

export default ariaSlice.reducer
